module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c03-cd2a084d17151f374bc4a8691e95156f.jpg";